"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import type { DisplayTz } from "./meme-calendar.helpers";
import MemeCalendar from "./MemeCalendar";
import MemeCalendarOverview from "./MemeCalendarOverview";
export default function MemesMintingCalendar() {
  const $ = _c(19);
  const [displayTz, setDisplayTz] = useState("local");
  const t0 = `${"tw-px-4 tw-py-1.5 tw-text-sm tw-font-medium tw-border tw-transition-colors tw-duration-200"} ${displayTz === "local" ? "tw-bg-blue-600 tw-text-white tw-border-blue-500 hover:tw-bg-blue-700" : "tw-bg-transparent tw-text-gray-300 tw-border-gray-600 hover:tw-bg-gray-700 hover:tw-text-white"} tw-rounded-l-md tw-border-r-0`;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setDisplayTz("local");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== t0) {
    t2 = <button className={t0} onClick={t1} title="Show local time">Local</button>;
    $[1] = t0;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `${"tw-px-4 tw-py-1.5 tw-text-sm tw-font-medium tw-border tw-transition-colors tw-duration-200"} ${displayTz === "utc" ? "tw-bg-blue-600 tw-text-white tw-border-blue-500 hover:tw-bg-blue-700" : "tw-bg-transparent tw-text-gray-300 tw-border-gray-600 hover:tw-bg-gray-700 hover:tw-text-white"} tw-rounded-r-md`;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setDisplayTz("utc");
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t3) {
    t5 = <button className={t3} onClick={t4} title="Show UTC">UTC</button>;
    $[4] = t3;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t2 || $[7] !== t5) {
    t6 = <div className="tw-flex tw-justify-end"><div className="tw-inline-flex">{t2}{t5}</div></div>;
    $[6] = t2;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== displayTz) {
    t7 = <div className="tw-w-full"><MemeCalendarOverview displayTz={displayTz} /></div>;
    $[9] = displayTz;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== displayTz) {
    t8 = <div className="tw-w-full"><MemeCalendar displayTz={displayTz} /></div>;
    $[11] = displayTz;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t7 || $[14] !== t8) {
    t9 = <div className="tw-flex tw-flex-wrap tw-gap-8">{t7}{t8}</div>;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t6 || $[17] !== t9) {
    t10 = <div className="tw-flex tw-flex-col tw-gap-3">{t6}{t9}</div>;
    $[16] = t6;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
}